<div class="row">
  <div class="col-xs-12">
    <h4>{{ 'STOP_COOKIES.TITLE'|translate }}</h4>
    <p>{{ 'STOP_COOKIES.DESCRIPTION'|translate }}</p>
  </div>
</div>

<ng-container *ngIf="!loading; else loadingSpinner">
  <ng-container *ngIf="!error; else loadError">

    <!-- Qué fuente está usando api2 REALMENTE. Va arriba de todo: si el
         refresher renovó bien pero api2 sigue sirviendo una cookie vieja del
         Google Sheet, el resto de la pantalla estaría diciendo una verdad que
         no es la que importa. -->
    <!-- OJO con el nivel: UNKNOWN y GOOGLE_SHEET NO son lo mismo.
         - GOOGLE_SHEET: divergencia REAL. api2 está sirviendo otra cookie. Rojo.
         - UNKNOWN: api2 no publicó su huella en la última hora. Como solo
           consulta cupos de 8 a 23 UTC y la key tiene TTL de 1h, esto pasa
           TODAS las madrugadas sobre un sistema sano. Pintarlo en rojo entrena
           a la gente a ignorar el banner, y el día que la divergencia sea de
           verdad nadie lo va a mirar. Va en tono neutro. -->
    <div class="row" *ngIf="status?.consumption?.diverged">
      <div class="col-xs-12">
        <div class="alert alert-danger" *ngIf="status.consumption.source === 'GOOGLE_SHEET'">
          <span class="material-symbols-rounded">warning</span>
          {{ 'STOP_COOKIES.DIVERGED'|translate }}
        </div>
        <div class="alert alert-warning" *ngIf="status.consumption.source !== 'GOOGLE_SHEET'">
          <span class="material-symbols-rounded">info</span>
          {{ 'STOP_COOKIES.CONSUMPTION_UNKNOWN'|translate }}
        </div>
      </div>
    </div>

    <!-- Avisos del backend: lista de notificados vacía, cron apagado, etc. -->
    <div class="row" *ngIf="status?.warnings?.length">
      <div class="col-xs-12">
        <div class="alert alert-warning" *ngFor="let warning of status.warnings">
          {{ warning }}
        </div>
      </div>
    </div>

    <!-- Estado de cada cookie -->
    <div class="row">
      <div class="col-xs-12">
        <div class="table-responsive">
          <table class="table table-hover table-condensed">
            <thead>
              <tr>
                <th class="sap"></th>
                <th>{{ 'STOP_COOKIES.KEY'|translate }}</th>
                <th>{{ 'STOP_COOKIES.LOADED_AT'|translate }}</th>
                <th>{{ 'STOP_COOKIES.EXPIRES_AT'|translate }}</th>
                <th class="sap">{{ 'STOP_COOKIES.FINGERPRINT'|translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cookie of status?.cookies">
                <td class="sap">
                  <!-- La cookie corta figura vencida casi siempre por diseño
                       (vive ~5 min y solo se reescribe cada ~24h; api2 la
                       renueva bajo demanda). Un semáforo ahí sería una alarma
                       permanente sobre algo que funciona bien. -->
                  <span *ngIf="cookie.expectedStale; else semaforo"
                    class="material-symbols-rounded text-muted"
                    title="{{ 'STOP_COOKIES.EXPECTED_STALE'|translate }}">info</span>
                  <ng-template #semaforo>
                    <status-indicator [status]="cookie.status"></status-indicator>
                  </ng-template>
                </td>
                <td>
                  <strong>{{ cookie.label }}</strong>
                  <br>
                  <small class="text-muted">{{ cookie.name }}</small>
                </td>
                <td>
                  {{ cookie.loadedAt | date:'dd/MM/yyyy HH:mm' }}
                  <br>
                  <small class="text-muted">{{ cookie.loadedAtHuman }}</small>
                </td>
                <td>
                  {{ cookie.expiresAt | date:'dd/MM/yyyy HH:mm' }}
                  <br>
                  <small class="text-muted">{{ cookie.expiresAtHuman }}</small>
                </td>
                <td class="sap">
                  <code>{{ cookie.fingerprint }}</code>
                </td>
              </tr>
              <tr *ngIf="!status?.cookies?.length">
                <td colspan="5" class="text-center text-muted">
                  {{ 'STOP_COOKIES.NO_DATA'|translate }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Cron y última corrida -->
    <div class="row">
      <div class="col-sm-6">
        <h5>{{ 'STOP_COOKIES.CRON_TITLE'|translate }}</h5>
        <dl class="dl-horizontal">
          <dt>{{ 'STOP_COOKIES.CRON_ENABLED'|translate }}</dt>
          <dd>
            <span *ngIf="status?.cron?.enabled">{{ 'STOP_COOKIES.CRON_ENABLED_YES'|translate }}</span>
            <span *ngIf="!status?.cron?.enabled" class="text-muted">
              {{ 'STOP_COOKIES.CRON_DISABLED'|translate }}
            </span>
          </dd>

          <dt>{{ 'STOP_COOKIES.NEXT_RENEWAL'|translate }}</dt>
          <dd>
            {{ status?.cron?.nextRenewalAt | date:'dd/MM/yyyy HH:mm' }}
            <small class="text-muted">{{ status?.cron?.nextRenewalAtHuman }}</small>
          </dd>

          <!-- El poll es el chequeo cada 5 min, que casi siempre es un no-op
               barato. No es lo mismo que la renovación real. -->
          <dt>{{ 'STOP_COOKIES.NEXT_POLL'|translate }}</dt>
          <dd>
            <small class="text-muted">{{ status?.cron?.nextPollAtHuman }}</small>
          </dd>
        </dl>
      </div>

      <div class="col-sm-6">
        <h5>{{ 'STOP_COOKIES.LAST_RUN_TITLE'|translate }}</h5>
        <dl class="dl-horizontal">
          <dt>{{ 'STOP_COOKIES.LAST_RUN'|translate }}</dt>
          <dd>
            {{ status?.lastRun?.ranAt | date:'dd/MM/yyyy HH:mm' }}
            <small class="text-muted">{{ status?.lastRun?.ranAtHuman }}</small>
          </dd>

          <dt>{{ 'STOP_COOKIES.OUTCOME'|translate }}</dt>
          <dd>{{ ('STOP_COOKIES.OUTCOME_' + (status?.lastRun?.outcome | uppercase))|translate }}</dd>

          <dt *ngIf="status?.lastRun?.errorMessage">{{ 'STOP_COOKIES.ERROR'|translate }}</dt>
          <dd *ngIf="status?.lastRun?.errorMessage" class="text-danger">
            <small>{{ status.lastRun.errorMessage }}</small>
          </dd>
        </dl>
      </div>
    </div>

    <!-- Renovación manual -->
    <div class="row">
      <div class="col-xs-12">
        <hr>

        <!-- Panel no bloqueante mientras corre: el usuario puede seguir
             navegando. Si se va y vuelve, el backend sigue diciendo "running" y
             la vista reengancha el poleo sola. -->
        <div class="alert alert-info" *ngIf="refreshing">
          <spinner></spinner>
          {{ 'STOP_COOKIES.REFRESHING'|translate }}
        </div>

        <div class="alert alert-danger" *ngIf="actionError">
          {{ actionError|translate }}
        </div>

        <!-- Caso `already_valid`: la cookie seguía vigente, no se hizo login ni
             se gastó cuota. Sin este mensaje el botón parecería no hacer nada. -->
        <div class="alert alert-info" *ngIf="actionMessage">
          {{ actionMessage }}
        </div>

        <button type="button" class="btn btn-agree" (click)="refresh()" [disabled]="!canRefresh">
          {{ 'STOP_COOKIES.REFRESH'|translate }}
        </button>

        <button type="button" class="btn btn-link" (click)="reload()" [disabled]="processing">
          {{ 'STOP_COOKIES.RELOAD'|translate }}
        </button>

        <p class="help-block" *ngIf="status?.rateLimit">
          {{ 'STOP_COOKIES.RATE_LIMIT'|translate:{
            remaining: status.rateLimit.remaining,
            limit: status.rateLimit.limit
          } }}
          <span *ngIf="status.rateLimit.resetsAtHuman">— {{ status.rateLimit.resetsAtHuman }}</span>
        </p>
        <p class="help-block">{{ 'STOP_COOKIES.REFRESH_HELP'|translate }}</p>
      </div>
    </div>

    <!-- Usuarios que reciben el aviso si la renovación falla (por company) -->
    <div class="row">
      <div class="col-xs-12">
        <hr>
        <h5>{{ 'STOP_COOKIES.NOTIFIED_TITLE'|translate }}</h5>
        <p class="help-block">{{ 'STOP_COOKIES.NOTIFIED_HELP'|translate }}</p>
      </div>

      <div class="col-sm-6" *ngIf="teamMembers">
        <!-- Select múltiple nativo en vez del componente `selectize` del repo:
             ese wrapper resuelve sus opciones por searchURL/type y su @Input
             `options` es privado, así que no admite una lista ya cargada en
             memoria como esta. Para elegir entre los representantes de la
             company, un select nativo alcanza y no arrastra jQuery. -->
        <div class="form-group">
          <label class="control-label" for="stop-notified-users">
            {{ 'STOP_COOKIES.NOTIFIED_PLACEHOLDER'|translate }}
          </label>
          <select
            id="stop-notified-users"
            class="form-control"
            multiple
            size="6"
            [(ngModel)]="selectedUserIds"
            [disabled]="savingUsers"
            name="notifiedUsers">
            <option *ngFor="let member of teamMembers" [ngValue]="member.user?.id">
              {{ member.name }} — {{ member.email }}
            </option>
          </select>
        </div>

        <div class="alert alert-success" *ngIf="usersSaved">
          {{ 'STOP_COOKIES.NOTIFIED_SAVED'|translate }}
        </div>

        <button type="button" class="btn btn-agree" (click)="saveNotifiedUsers()"
          [disabled]="savingUsers">
          {{ 'STOP_COOKIES.NOTIFIED_SAVE'|translate }}
        </button>
      </div>
    </div>

  </ng-container>
</ng-container>

<ng-template #loadError>
  <div class="alert alert-danger">
    {{ 'STOP_COOKIES.LOAD_ERROR'|translate }}
  </div>
</ng-template>

<ng-template #loadingSpinner>
  <div class="loading">
    <spinner message="{{ 'GLOBAL.LOADING'|translate }}"></spinner>
  </div>
</ng-template>
